export class UserAccount {
  private operatorUuid: string;
  private superUser = false;
  private active = true;

  getOperatorUuid(): string {
    return this.operatorUuid;
  }

  setOperatorUuid(operatorUuid: string): UserAccount {
    this.operatorUuid = operatorUuid;

    return this;
  }

  getSuperUser(): boolean {
    return this.superUser;
  }

  setSuperUser(superUser: boolean): UserAccount {
    this.superUser = superUser;

    return this;
  }

  getActive(): boolean {
    return this.active;
  }

  setActive(active: boolean): UserAccount {
    this.active = active;
    
    return this;
  }
}